// Where the pointer is, for marks whose eyes follow it (AssistantMark's
// mascots). One listener for the whole page, however many eyes look,
// read at most once a frame; inactive while the pointer is off the window.
import { reactive } from 'vue'

export const pointer = reactive({ x: 0, y: 0, active: false })

let users = 0
let frame = 0
let next: { x: number; y: number } | null = null

function onMove(e: PointerEvent) {
  next = { x: e.clientX, y: e.clientY }
  if (!frame) {
    frame = requestAnimationFrame(() => {
      frame = 0
      if (next) Object.assign(pointer, next, { active: true })
    })
  }
}
function onLeave() {
  pointer.active = false
}

/** Starts following the pointer; the returned function stops. */
export function followPointer(): () => void {
  if (typeof window === 'undefined') return () => {}
  if (users++ === 0) {
    window.addEventListener('pointermove', onMove, { passive: true })
    document.documentElement.addEventListener('pointerleave', onLeave)
  }
  return () => {
    if (--users === 0) {
      window.removeEventListener('pointermove', onMove)
      document.documentElement.removeEventListener('pointerleave', onLeave)
      pointer.active = false
    }
  }
}
